import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProfileModal from './ProfileModal';
import { addRecruiterWishlist, removeRecruiterWishlist, getProfileByEmail } from "../../../redux/actions/halloffame";
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';

const RowCandidateCard = ({ rank, name, title, company, profilePicture, isWishlisted, candidateEmail, onLogin, onRemove, experience, pastTitle, skillEvidence, isBasicSearch }) => {

    const dispatch = useDispatch();
    const [isWishlistedLocal, setIsWishlistedLocal] = useState(isWishlisted);

    useEffect(() => {
        setIsWishlistedLocal(isWishlisted);
    }, [isWishlisted]);

    const [fullProfile, setFullProfile] = useState({});
    const [isFetchingFullProfile, setIsFetchingFullProfile] = useState(false);
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
    const recruiterAccessToken = useSelector((store) => store?.hallOfFame?.recruiterAccessToken);

    const checkIfLoggedIn = () => {
        if (!recruiterAccessToken) {
            onLogin();
            return false;
        }
        return true;
    }
    const addWishlistedProfile = (email) => {
        if (!checkIfLoggedIn()) return;
        Mixpanel.track(Constants.Mixpanel.RECRUITER_CANDIDATE_PROFILE_SHORTLIST_ADDED);
        dispatch(addRecruiterWishlist(recruiterAccessToken, email, (response) => {
            setIsWishlistedLocal(true);
            console.log(response);
        }, (error) => {
            console.log(error);
        }));
    }

    const removeWishlistedProfile = (email) => {
        if (!checkIfLoggedIn()) return;
        Mixpanel.track(Constants.Mixpanel.RECRUITER_CANDIDATE_PROFILE_SHORTLIST_REMOVED);
        dispatch(removeRecruiterWishlist(recruiterAccessToken, email, (response) => {
            setIsWishlistedLocal(false);
            if (onRemove) onRemove();
            console.log(response);
        }, (error) => {
            console.log(error);
        }));
    }

    const getInitials = (fullName) => {
        const normalizedName = (fullName || '').trim();
        if (!normalizedName) return 'NA';
        const nameParts = normalizedName.split(/\s+/).filter(Boolean);
        if (!nameParts.length) return 'NA';
        if (nameParts.length === 1) return nameParts[0].slice(0, 2).toUpperCase();
        return `${nameParts[0][0] || ''}${nameParts[1][0] || ''}`.toUpperCase();
    };

    const getUserProfileByEmail = (email) => {
        if (!checkIfLoggedIn()) return;
        Mixpanel.track(isBasicSearch ? Constants.Mixpanel.RECRUITER_RESULTS_PAGE_BASIC_CANDIDATE_PROFILE_CARD_CLICKED : Constants.Mixpanel.RECRUITER_RESULTS_PAGE_BOTTOM_CANDIDATE_PROFILE_CARD_CLICKED);
        setIsFetchingFullProfile(true);
        dispatch(getProfileByEmail(email, (response) => {
            console.log(response?.profile);
            setFullProfile(response?.profile);
            setIsFetchingFullProfile(false);
            setIsProfileModalOpen(true);
        }, (error) => {
            console.log(error);
            setIsFetchingFullProfile(false);
        }));
    };

    return (
        <div className="flex w-full items-center gap-3 rounded-2xl border border-gray-200/10 bg-[#0d1b26] py-2 px-[14px] sm:gap-4 sm:p-4 cursor-pointer"
            style={{
                WebkitTapHighlightColor: "transparent",
            }}
            onClick={(e) => {
                e.stopPropagation();
                getUserProfileByEmail(candidateEmail);
            }}
        >
            <div className="relative flex-shrink-0 rounded-full items-center justify-center flex">

                {profilePicture ? (
                    <img
                        className="h-12 w-12 rounded-full object-cover sm:h-14 sm:w-14"
                        alt="profile"
                        src={profilePicture}
                    />
                ) : (
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#283b4a] text-[20px] font-bold uppercase text-[#F7E394]">
                        {getInitials(name)}
                    </div>
                )}
                {rank && <div className="absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center rounded-lg bg-[#f7e394] shadow-md sm:h-7 sm:w-7">
                    <span className="font-['Inter',Helvetica] text-xs font-bold text-[#522404] sm:text-sm">
                        {rank}
                    </span>
                </div>}
            </div>
            <div className="flex flex-col items-start min-w-0">
                <h3 className="font-['Inter',Helvetica] text-sm font-bold leading-tight text-white sm:text-base">
                    {name} {' - '}
                    { experience === 0 || experience === null ? 'Fresher' : experience > 12 ? `${Math.floor(experience / 12)}+ years` : `${experience} months`}
                </h3>
                <p className="font-['Inter',Helvetica] text-xs font-bold text-[#a7b6c2] sm:text-sm">
                    {pastTitle === '' && skillEvidence?.length > 0 ? 'Top skills: ' + skillEvidence[0] ?? " " +  skillEvidence[1] ?? '' : title === pastTitle ? title : pastTitle === '' ? title : 'Ex: ' + pastTitle}
                </p>
                <p className="mt-2 font-['Inter',Helvetica] text-xs font-normal text-[#a7b6c2] sm:text-sm line-clamp-1">
                    {company === 'Not Specified' ? '' : company === 'Not specified' ? '' : company}
                </p>
            </div>
            <div className="relative ml-auto flex-shrink-0 inline-flex items-end justify-center gap-0.5 cursor-pointer" style={{ WebkitTapHighlightColor: "transparent" }} onClick={(e) => {
                e.stopPropagation();
                isWishlistedLocal ? removeWishlistedProfile(candidateEmail) : addWishlistedProfile(candidateEmail);
            }}>
                <img src={`${isWishlistedLocal ? "https://assets.learntube.ai/files/halloffame/recruiter/Button%20(1).svg" : "https://assets.learntube.ai/files/halloffame/recruiter/Button.svg"}`} alt="shortlist" className="h-9 w-9 text-white" />
            </div>
            {isProfileModalOpen && <ProfileModal fullProfile={fullProfile} matchScore={rank} setIsProfileModalOpen={setIsProfileModalOpen} isFetchingFullProfile={isFetchingFullProfile} isWishlistedLocal={isWishlistedLocal} addWishlistedProfile={addWishlistedProfile} removeWishlistedProfile={removeWishlistedProfile} />}
        </div>
    );
};

export default RowCandidateCard;
